import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export function useDequeueCall(onBeforeDequeue?: () => void) {
  const [isDequeuing, setIsDequeuing] = useState(false);

  const dequeue = async (callSid: string) => {
    if (isDequeuing) return;
    setIsDequeuing(true);
    onBeforeDequeue?.();

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('No session');

      const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID;
      const res = await fetch(
        `https://${projectId}.supabase.co/functions/v1/dequeue-call`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ callSid }),
        }
      );

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to dequeue');
      }

      toast.success('Opkald overtaget');
    } catch (err: any) {
      console.error('Dequeue error:', err);
      toast.error('Kunne ikke overtage opkaldet');
    } finally {
      setIsDequeuing(false);
    }
  };

  return { dequeue, isDequeuing };
}
